<mat-dialog-content class="mat-typography">
  <h3>
    Certificado Digital
  </h3>

  <div style="display: flex;">
    <mat-radio-group ngDefaultControl [formControl]="opcaoAutenticacaoSelecionada" style="padding-right: 4em;">
      @for (opcao of opcoesCertificado; track opcao) {
        <mat-radio-button [value]="opcao.id" [disabled]="opcao.desabilitado">
          {{opcao.descricao}}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
  @if (data.solicitarSenha && opcaoAutenticacaoSelecionada.value != tipoAutenticacaoPadrao) {
    <mat-form-field style="min-width: 270px;">
      <mat-label>Senha</mat-label>
      <input matInput [formControl]="senha" placeholder="Informe a senha do certificado"
        [type]="esconderSenha ? 'password' : 'text'" />
        <mat-icon matSuffix (click)="esconderSenha = !esconderSenha">
          {{esconderSenha ? 'visibility_off' : 'visibility'}}
        </mat-icon>
      </mat-form-field>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button [mat-dialog-close]="true" (click)="service.fechar()">
      Cancelar
    </button>
    <button type="submit" (click)="service.confirmar(senha.value, data.logar, opcaoAutenticacaoSelecionada.value)"
      mat-flat-button color="primary"
            [disabled]="opcaoAutenticacaoSelecionada.value === null ||
            opcaoAutenticacaoSelecionada.value == tipoCertificadoUsuario && data.solicitarSenha &&
            (senha.invalid || (!senha.dirty || !senha.touched))"
      >
      Confirmar
    </button>
  </mat-dialog-actions>
